export default {
    path: 'zfcg',
    component: () => import(/*webpackChunkName: 'projectZfcg'*/ '@layout/empty'),
    children: [
       {
            path:"detail",
            component: () => import(/*webpackChunkName: 'projectZfcg'*/'@views/bidding/views/project/zfcg/detail'),
            meta: {
                title: '项目详情',
            },
        }
    ]
}
